// extracted by mini-css-extract-plugin
export default {"pageLayout":"LoginRecords-module__pageLayout___AWMDR"};